import { ScrollVanishDirective } from './scroll-vanish.directive';
import { SelectOnClickDirective } from './select-on-click.directive';
import { NgModule } from '@angular/core';
@NgModule({
  declarations: [
    SelectOnClickDirective,
    ScrollVanishDirective
  ],
  imports: [],
  exports: [
    SelectOnClickDirective,
    ScrollVanishDirective
  ]
})
export class DirectivesModule {}
